import { BenchmarkingRequestParams, useFiltersStore } from '@/hooks'
import { useMemo } from 'react'

export const useRemoveRootNodeIdFilter = (
    filters: BenchmarkingRequestParams
) => {
    const rootNode = useFiltersStore((state) => state.rootNode)

    return useMemo(() => {
        if (
            filters['nodeIds[]'] &&
            rootNode?.nodeId &&
            filters['nodeIds[]'].split(',').length === 1 &&
            Number(filters['nodeIds[]']) === rootNode.nodeId
        ) {
            // When only rootNode selected, treat as no node filter applied
            return {
                ...filters,
                ['nodeIds[]']: '',
            }
        }
        return filters
    }, [filters, rootNode])
}
